import { render, staticRenderFns } from "./AdminResourceUsage.vue?vue&type=template&id=70f6f7d2"
import script from "./AdminResourceUsage.vue?vue&type=script&lang=js"
export * from "./AdminResourceUsage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports